var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 92,
    viewBox: "0 0 90 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 47.0999C90 43.9999 89.7 40.7999 89.2 37.7999H45.9V55.4999H70.7C69.7 61.1999 66.4 66.1999 61.5 69.3999L76.3 80.8999C85 72.7999 90 60.9999 90 47.0999Z",
    fill: "#4280EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9 91.8999C58.3 91.8999 68.7 87.7999 76.3 80.7999L61.5 69.3999C57.4 72.1999 52.1 73.7999 45.9 73.7999C33.9 73.7999 23.8 65.6999 20.1 54.8999L4.90002 66.5999C12.7 82.0999 28.5 91.8999 45.9 91.8999Z",
    fill: "#34A353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1 54.7999C18.2 49.0999 18.2 42.8999 20.1 37.1999L4.90002 25.3999C-1.59998 38.3999 -1.59998 53.6999 4.90002 66.5999L20.1 54.7999Z",
    fill: "#F6B704"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9 18.2999C52.4 18.1999 58.8 20.6999 63.5 25.1999L76.6 11.9999C68.3 4.19989 57.3 -0.000110182 45.9 0.0998898C28.5 0.0998898 12.7 9.89989 4.90002 25.3999L20.1 37.1999C23.8 26.2999 33.9 18.2999 45.9 18.2999Z",
    fill: "#E54335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.2e784a27eaf5f8c9eacc5303817489a4.svg";
export { ForwardRef as ReactComponent };